// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mn-c";
export var backButton = "_mn-4";
export var backIcon = "_mn-5";
export var chevronShortcut = "_mn-6";
export var container = "_mn-1";
export var editor = "_mn-8";
export var editorWrapper = "_mn-7";
export var prefix = "_mn-2";
export var searchIcon = "_mn-3";
export var suffix = "_mn-9";
export var suffixContent = "_mn-a";
export var suffixText = "_mn-b";
export var wrapper = "_mn-0";